/**
 * Popover Component
 */
import React, { useRef, MutableRefObject } from 'react';
import ReactDOM from 'react-dom';
import { withTheme } from 'styled-components';
import { PopoverProps, ShowOnEvent } from './popover.types'
import PopperComponent from './popperComponent';
import { ReferenceWrapper } from './popover.style';
import useControlledState from '../hooks/useControlledState/useControlledState';

const Popover = (props: PopoverProps) => {

    const { 
        showMultiple, 
        showOnEvent, 
        children, 
        portalTarget, 
        onOpen, 
        onClose, 
        closeOnPopperClick,
        isOpen,
        defaultIsOpen,
    } = props;

    const [isPopoverOpen, setIsPopoverOpen] = useControlledState({
        controlled: isOpen,
        default: defaultIsOpen,
        name: 'Popover',
    });
    const referenceElement: MutableRefObject<HTMLSpanElement | null> = useRef<HTMLSpanElement>(null);
    const clickOutsidePopperHandler = () => {

        const couldClose = !showMultiple && isPopoverOpen;
        if (couldClose) {

            closePopover();

        }

    }

    const openPopover = () => {
        setIsPopoverOpen(true);
        if(onOpen) {
            onOpen();
        }
    }
    const closePopover = () => {
        setIsPopoverOpen(false);
        if(onClose) {
            onClose();
        }
    }
    const togglePopover = () => {
        if(isPopoverOpen) {
            closePopover();
        } else {
            openPopover();
        } 
    }

    const clickHandlers = {
        onClick: (event: Event) => {
            togglePopover();
        }
    }
    const hoverHandlers = {
        onMouseEnter: openPopover,
        onMouseLeave: closePopover,
    }
    const popper = (
        <PopperComponent 
            referenceElement={referenceElement} 
            clickOutsidePopperHandler={clickOutsidePopperHandler} 
            popperClickHandler={closeOnPopperClick ? closePopover : undefined}
            {...props} 
        />
    );
    const hasDocument = typeof document !== undefined;
    const popperElement = portalTarget && hasDocument ? 
        ReactDOM.createPortal(popper, portalTarget) 
        : popper;

    return (<>
            <ReferenceWrapper 
                {...(showOnEvent === ShowOnEvent.CLICK ? clickHandlers : hoverHandlers)} 
                ref={referenceElement}
            >
                {children}
            </ReferenceWrapper>
            {isPopoverOpen ? (
                popperElement
            ) : null}
        </>);
}

Popover.defaultProps = {
    showOnEvent: ShowOnEvent.CLICK,
    showMultiple: false,
    preventOverflow: true,
    overflowOverReference: false,
    flipPopover: true,
    showArrow: true,
    closeOnPopperClick: true,
    defaultIsOpen: false,
}

export default withTheme(Popover);
